import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="d-editor-container">
  <div class="d-editor-textarea-column">
    {{yield}}
    {{#if this.showFormTemplateForm}}
      {{#if (gt @formTemplateIds.length 1)}}
        <FormTemplateChooser
          @filteredIds={{@formTemplateIds}}
          @value={{this.selectedFormTemplateId}}
          @onChange={{this.updateSelectedFormTemplateId}}
          @options={{hash maximum=1}}
          class="composer-select-form-template"
        />
      {{/if}}
      <form id="form-template-form">
        <FormTemplateField::Wrapper
          @id={{this.selectedFormTemplateId}}
          @initialValues={{@formTemplateInitialValues}}
          @onSelectFormTemplate={{@onSelectFormTemplate}}
        />
      </form>
    {{else}}
      <div
        class="d-editor-textarea-wrapper
          {{if this.disabled 'disabled'}}
          {{if this.isEditorFocused 'in-focus'}}"
      >
        <div class="d-editor-button-bar" role="toolbar">
          {{#each this.toolbar.groups as |group|}}
            {{#each group.buttons as |b|}}
              {{#if (b.condition this)}}
                {{#if b.popupMenu}}
                  <ToolbarPopupMenuOptions
                    @content={{this.popupMenuOptions}}
                    @onChange={{this.onPopupMenuAction}}
                    @onOpen={{action b.action b}}
                    @tabindex={{-1}}
                    @onKeydown={{this.rovingButtonBar}}
                    @options={{hash icon=b.icon focusAfterOnChange=false}}
                    class={{b.className}}
                  />
                {{else}}
                  <DButton
                    @action={{fn (action b.action) b}}
                    @translatedTitle={{b.title}}
                    @label={{b.label}}
                    @icon={{b.icon}}
                    @preventFocus={{b.preventFocus}}
                    @onKeyDown={{this.rovingButtonBar}}
                    tabindex={{b.tabindex}}
                    class={{b.className}}
                  />
                {{/if}}
              {{/if}}
            {{/each}}
          {{/each}}
        </div>

        <ConditionalLoadingSpinner @condition={{this.loading}} />
        <DTextarea
          @autocomplete="off"
          @tabindex={{this.tabindex}}
          @value={{this.value}}
          @placeholder={{this.placeholderTranslated}}
          @aria-label={{this.placeholderTranslated}}
          @disabled={{this.disabled}}
          @input={{this.change}}
          @focusIn={{action "focusIn"}}
          @focusOut={{action "focusOut"}}
          class="d-editor-input"
        />
        <PopupInputTip @validation={{this.validation}} />
        <PluginOutlet
          @name="after-d-editor"
          @connectorTagName="div"
          @outletArgs={{this.outletArgs}}
        />
      </div>
    {{/if}}
  </div>

  <div
    class="d-editor-preview-wrapper {{if this.forcePreview 'force-preview'}}"
  >
    <div class="d-editor-preview">
      {{#unless this.siteSettings.enable_diffhtml_preview}}
        {{html-safe this.preview}}
      {{/unless}}
    </div>
    <span class="d-editor-plugin">
      <PluginOutlet
        @name="editor-preview"
        @connectorTagName="div"
        @outletArgs={{this.outletArgs}}
      />
    </span>
  </div>
</div>

<EmojiPicker
  @isActive={{this.emojiPickerIsActive}}
  @isEditorFocused={{this.isEditorFocused}}
  @initialFilter={{this.emojiFilter}}
  @emojiSelected={{action "emojiSelected"}}
  @onEmojiPickerClose={{this.onEmojiPickerClose}}
/>
*/
{
  "id": "rQHcPAd/",
  "block": "[[[10,0],[14,0,\"d-editor-container\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"d-editor-textarea-column\"],[12],[1,\"\\n    \"],[18,6,null],[1,\"\\n\"],[41,[30,0,[\"showFormTemplateForm\"]],[[[41,[28,[37,2],[[30,1,[\"length\"]],1],null],[[[1,\"        \"],[8,[39,3],[[24,0,\"composer-select-form-template\"]],[[\"@filteredIds\",\"@value\",\"@onChange\",\"@options\"],[[30,1],[30,0,[\"selectedFormTemplateId\"]],[30,0,[\"updateSelectedFormTemplateId\"]],[28,[37,4],null,[[\"maximum\"],[1]]]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,\"form\"],[14,1,\"form-template-form\"],[12],[1,\"\\n        \"],[8,[39,5],null,[[\"@id\",\"@initialValues\",\"@onSelectFormTemplate\"],[[30,0,[\"selectedFormTemplateId\"]],[30,2],[30,3]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[15,0,[29,[\"d-editor-textarea-wrapper\\n          \",[52,[30,0,[\"disabled\"]],\"disabled\"],\"\\n          \",[52,[30,0,[\"isEditorFocused\"]],\"in-focus\"]]]],[12],[1,\"\\n        \"],[10,0],[14,0,\"d-editor-button-bar\"],[14,\"role\",\"toolbar\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"toolbar\",\"groups\"]]],null]],null],null,[[[42,[28,[37,7],[[28,[37,7],[[30,4,[\"buttons\"]]],null]],null],null,[[[41,[28,[30,5,[\"condition\"]],[[30,0]],null],[[[41,[30,5,[\"popupMenu\"]],[[[1,\"                  \"],[8,[39,8],[[16,0,[30,5,[\"className\"]]]],[[\"@content\",\"@onChange\",\"@onOpen\",\"@tabindex\",\"@onKeydown\",\"@options\"],[[30,0,[\"popupMenuOptions\"]],[30,0,[\"onPopupMenuAction\"]],[28,[37,9],[[30,0],[30,5,[\"action\"]],[30,5]],null],-1,[30,0,[\"rovingButtonBar\"]],[28,[37,4],null,[[\"icon\",\"focusAfterOnChange\"],[[30,5,[\"icon\"]],false]]]]],null],[1,\"\\n\"]],[]],[[[1,\"                  \"],[8,[39,10],[[16,\"tabindex\",[30,5,[\"tabindex\"]]],[16,0,[30,5,[\"className\"]]]],[[\"@action\",\"@translatedTitle\",\"@label\",\"@icon\",\"@preventFocus\",\"@onKeyDown\"],[[28,[37,11],[[28,[37,9],[[30,0],[30,5,[\"action\"]]],null],[30,5]],null],[30,5,[\"title\"]],[30,5,[\"label\"]],[30,5,[\"icon\"]],[30,5,[\"preventFocus\"]],[30,0,[\"rovingButtonBar\"]]]],null],[1,\"\\n\"]],[]]]],[]],null]],[5]],null]],[4]],null],[1,\"        \"],[13],[1,\"\\n\\n        \"],[8,[39,12],null,[[\"@condition\"],[[30,0,[\"loading\"]]]],null],[1,\"\\n        \"],[8,[39,13],[[24,0,\"d-editor-input\"]],[[\"@autocomplete\",\"@tabindex\",\"@value\",\"@placeholder\",\"@aria-label\",\"@disabled\",\"@input\",\"@focusIn\",\"@focusOut\"],[\"off\",[30,0,[\"tabindex\"]],[30,0,[\"value\"]],[30,0,[\"placeholderTranslated\"]],[30,0,[\"placeholderTranslated\"]],[30,0,[\"disabled\"]],[30,0,[\"change\"]],[28,[37,9],[[30,0],\"focusIn\"],null],[28,[37,9],[[30,0],\"focusOut\"],null]]],null],[1,\"\\n        \"],[8,[39,14],null,[[\"@validation\"],[[30,0,[\"validation\"]]]],null],[1,\"\\n        \"],[8,[39,15],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"after-d-editor\",\"div\",[30,0,[\"outletArgs\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,0],[15,0,[29,[\"d-editor-preview-wrapper \",[52,[30,0,[\"forcePreview\"]],\"force-preview\"]]]],[12],[1,\"\\n    \"],[10,0],[14,0,\"d-editor-preview\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"siteSettings\",\"enable_diffhtml_preview\"]]],[[[1,\"        \"],[1,[28,[35,17],[[30,0,[\"preview\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"d-editor-plugin\"],[12],[1,\"\\n      \"],[8,[39,15],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"editor-preview\",\"div\",[30,0,[\"outletArgs\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,18],null,[[\"@isActive\",\"@isEditorFocused\",\"@initialFilter\",\"@emojiSelected\",\"@onEmojiPickerClose\"],[[30,0,[\"emojiPickerIsActive\"]],[30,0,[\"isEditorFocused\"]],[30,0,[\"emojiFilter\"]],[28,[37,9],[[30,0],\"emojiSelected\"],null],[30,0,[\"onEmojiPickerClose\"]]]],null]],[\"@formTemplateIds\",\"@formTemplateInitialValues\",\"@onSelectFormTemplate\",\"group\",\"b\",\"&default\"],false,[\"yield\",\"if\",\"gt\",\"form-template-chooser\",\"hash\",\"form-template-field/wrapper\",\"each\",\"-track-array\",\"toolbar-popup-menu-options\",\"action\",\"d-button\",\"fn\",\"conditional-loading-spinner\",\"d-textarea\",\"popup-input-tip\",\"plugin-outlet\",\"unless\",\"html-safe\",\"emoji-picker\"]]",
  "moduleName": "discourse/components/d-editor.hbs",
  "isStrictMode": false
});